import { Link } from "react-router-dom";
import { generateTags, TAG_LABELS } from "@/lib/articleTags";

const ArticleTags = ({ article }) => {
  const tags = generateTags(article);
  if (tags.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-4" data-testid="article-tags">
      {tags.map(tag => (
        <Link
          key={tag}
          to={`/glp-guide?tag=${tag}`}
          className="px-2.5 py-1 bg-white/80 text-[#4B5548] rounded-full text-xs font-medium hover:bg-[#2D6A4F] hover:text-white transition-colors border border-gray-200"
          data-testid={`tag-${tag}`}
        >
          {TAG_LABELS[tag] || tag}
        </Link>
      ))}
    </div>
  );
};

export default ArticleTags;
